import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { asyncScheduler, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Buttoms, DefaultListOrder } from '../../../private/shared/models/order-list';
import { IProductos, ISummaryPrice } from '../../../private/shared/models/productos';
import { ILimitsToast } from '../../models/ApplicationUser';
import { SummaryPriceDefault } from '../../models/Constants';
import { OperationsService } from '../../services/operations/operations.service';
import { ToastControllerService } from '../../services/toast-controller.service';
import { environment } from './../../../../environments/environment';
import { AppState } from './../../../store/app-reducers';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  @Input() product: IProductos = {} as IProductos;
  @Input() cardProductFilter: IProductos = {} as IProductos;
  @Input() addedFromSearch = false;
  @Input() claveProducto? = null;
  @Input() cajasSugeridas = 0;
  @Input() addDown = false;
  @Input() keyAccounts = false;

  @Output() addProducto? = new EventEmitter<{ producto: IProductos, productsSelect: number }>();
  @Output() addProductoGafc? = new EventEmitter<{ producto: IProductos, productsSelect: number }>();

  public isDisabled = true;
  public state = true;
  public isPreviousValue = false;
  public resetRange = false;
  public productsSelect = 0;
  public isFactorCl = environment.production;
  public colDescrip = window.innerWidth >= 320 && window.innerWidth < 360 ? 5 : 6;
  public colButtoms = window.innerWidth >= 320 && window.innerWidth < 360 ? 4 : 3;
  public rangeInput: Buttoms = DefaultListOrder.componentContent.range.buttoms;

  private isMax = false;
  private LimitMaxCajas = 0;
  private LimitMaxMonto = 0;
  private summaryPrice: ISummaryPrice = SummaryPriceDefault;
  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private operationsS: OperationsService
    , private toastS: ToastControllerService
    , private translate: TranslateService
    , private store: Store<AppState>
    , private ref: ChangeDetectorRef
  ) {
    this.LimitMaxCajas = this.operationsS.LimitMaxCajas || 0;
    this.LimitMaxMonto = this.operationsS.LimitMaxMonto || 0;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('product')
      && changes.product.previousValue
      && changes.product.currentValue.id_producto !== changes.product.previousValue.id_producto
    ) {
      this.isPreviousValue = true;
      asyncScheduler.schedule(() => this.isPreviousValue = false, 50);
      this.comeBack((this.cardProductFilter.productos || 0));
    }
    if (changes.hasOwnProperty('cardProductFilter')) {
      this.state = (this.cardProductFilter.productos || 0) < 1;
    }

    this.productsSelect = (this.cardProductFilter.productos || 0) > 0 ? this.cardProductFilter.productos || 0 : this.cajasSugeridas;
    if (this.productsSelect === this.cardProductFilter.productos) {
      this.isDisabled = true;
      this.ref.detectChanges();
    } else {
      this.isDisabled = false;
    }
  }

  ngOnInit() {
    this.operationsS.summaryPriceTotal$()
      .pipe(
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(summaryPrice => {
        this.summaryPrice = summaryPrice
        this.isMax = this.LimitMaxMonto > 0 && this.summaryPrice.total_precio > this.LimitMaxMonto || this.LimitMaxCajas > 0 && (this.summaryPrice.FactorCl || 0) > this.LimitMaxCajas;
      });

    this.store.select('resizeView')
      .pipe(takeUntil(this.finishSubscriptions))
      .subscribe(resize => {
        this.colDescrip = window.innerWidth >= 320 && window.innerWidth < 360 ? 5 : 6;
        this.colButtoms = window.innerWidth >= 320 && window.innerWidth < 360 ? 4 : 3;
      });
  }

  async ngAfterViewInit() {
    const configurationRange: { initial: number; end: number } = this.translate.instant(`RangeSelector.Store`);
    this.rangeInput = { ...this.rangeInput, ...configurationRange };
  }

  ngOnDestroy(): void {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  public comeBack = async (productsSelect: number) => {
    const valid = !this.isMax && this.cajasSugeridas < 1 ? true : this.isMax ? false : this.cajasSugeridas > 0 ? false : true;
    if (valid) {
      // * Validación de precio maximo
      const totalPrice = this.summaryPrice.total_precio - ((this.cardProductFilter.productos || 0) * (this.cardProductFilter.precio || 0));
      const priceSelected = ((this.product.precio || 0) * productsSelect) + totalPrice;
      if (this.LimitMaxMonto > 0 && priceSelected > this.LimitMaxMonto) {
        await this.toastS.dismissToast();
        const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-prices');
        this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxMonto.toString()), color, icon, duration, clase, position, header);
        this.resetRange = true;
        asyncScheduler.schedule(() => this.resetRange = false, 50);
        return;
      }

      // * Validación de cajas maximo
      const totalCajas = ((this.summaryPrice.FactorCl || 0) - ((this.cardProductFilter.FactorCl || 0) * (this.cardProductFilter.productos || 0))) + ((this.cardProductFilter.FactorCl || 0) * productsSelect);
      if (this.LimitMaxCajas > 0 && totalCajas > this.LimitMaxCajas) {
        await this.toastS.dismissToast();
        const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-boxs');
        this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxCajas.toString()), color, icon, duration, clase, position, header);
        this.resetRange = true;
        asyncScheduler.schedule(() => this.resetRange = false, 50);
        return;
      }
    }

    this.productsSelect = productsSelect;
    if (productsSelect === this.cardProductFilter.productos) {
      this.isDisabled = true;
      this.ref.detectChanges();
    } else {
      this.isDisabled = false;
    }
    if (this.product.modelo === 1) {
      this.addProductoGafc?.emit({ producto: this.product, productsSelect: this.productsSelect });
    }
  }

  public onAddCart = async (producto: IProductos) => {
    // * Validación de precio maximo
    const totalPrice = this.summaryPrice.total_precio - ((this.cardProductFilter.productos || 0) * (this.cardProductFilter.precio || 0));
    const priceSelected = ((this.product.precio || 0) * this.productsSelect) + totalPrice;
    if (this.LimitMaxMonto > 0 && priceSelected > this.LimitMaxMonto) {
      await this.toastS.dismissToast();
      const { message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-prices');
      this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxMonto.toString()), color, icon, duration, clase, position);
      return;
    }

    // * Validación de cajas maximo
    const totalCajas = ((this.summaryPrice.FactorCl || 0) - ((this.cardProductFilter.FactorCl || 0) * (this.cardProductFilter.productos || 0))) + ((producto.FactorCl || 0) * this.productsSelect);
    if (this.LimitMaxCajas > 0 && totalCajas > this.LimitMaxCajas) {
      await this.toastS.dismissToast();
      const { message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-boxs');
      this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxCajas.toString()), color, icon, duration, clase, position);
      return;
    }

    if (this.productsSelect > 0) {
      this.state = false
      this.isDisabled = true
    } else if (this.productsSelect === 0) {
      this.state = true
      this.isDisabled = true
    }
    this.addProducto?.emit({ producto, productsSelect: this.productsSelect });
  }

}
